export default __webpack_public_path__ + "static/media/WebProjectsScreen.e8848d5b.gif";